export default "__VITE_ASSET__C2NKLFY4__"